import React from 'react';
import { Loader2 } from 'lucide-react';

const Button = ({ children, variant = 'primary', size = 'md', loading = false, icon: Icon, className = '', ...props }) => {
  const baseClasses = "inline-flex items-center justify-center rounded-xl font-semibold focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 focus:ring-offset-base";

  const variants = {
    primary: "bg-accent text-accent-ink",
    secondary: "bg-surface text-ink border border-line",
    success: "bg-accent text-accent-ink",
    danger: "bg-surface text-ink border border-line",
    outline: "bg-transparent border border-accent text-accent",
    ghost: "bg-transparent text-ink-subtle",
  };

  const sizes = {
    sm: "text-[11px] px-4 py-2",
    md: "text-[12px] px-5 py-2.5",
    lg: "text-[13px] px-6 py-3",
  };

  const disabledClass = "opacity-50 cursor-not-allowed";

  return (
    <button
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${props.disabled || loading ? disabledClass : ''} ${className}`}
      disabled={props.disabled || loading}
      {...props}
    >
      {loading ? (
        <>
          <Loader2 className="mr-2" size={16} />
          Loading
        </>
      ) : (
        <>
          {Icon && <Icon size={16} className="mr-2" />}
          {children}
        </>
      )}
    </button>
  );
};

export default Button;
